export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public details?: unknown,
  ) {
    super(message);
  }
}

const csrfToken = () =>
  document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content ?? "";

type RequestOptions = Omit<RequestInit, "body"> & { body?: unknown };

export async function apiFetch<T>(url: string, options: RequestOptions = {}): Promise<T> {
  const headers = new Headers(options.headers);
  headers.set("Accept", "application/json");
  headers.set("X-Requested-With", "XMLHttpRequest");

  const isFormData = options.body instanceof FormData;

  if (options.body !== undefined) {
    headers.set("X-CSRF-TOKEN", csrfToken());

    if (!isFormData) {
      headers.set("Content-Type", "application/json");
    }
  }

  const response = await fetch(url, {
    ...options,
    headers,
    credentials: "same-origin",
    body:
      options.body === undefined
        ? undefined
        : isFormData
          ? (options.body as FormData)
          : JSON.stringify(options.body),
  });

  const text = await response.text();
  let payload: { message?: string } | null = null;

  if (text) {
    try {
      payload = JSON.parse(text);
    } catch {
      throw new ApiError(
        "Il servizio chatbot non ha risposto in JSON. Controlla che l'API Laravel sia raggiungibile.",
        response.status,
      );
    }
  }

  if (!response.ok) {
    throw new ApiError(payload?.message ?? "Request failed", response.status, payload);
  }

  return payload as T;
}
